import classNames from "classnames";

import styles from "./LoadingCircle.module.scss";

const TICKS = 12;

/** Activity indicator for in-progress chats and workflows: twelve rounded
 *  ticks fading behind the leading one, drawn static (no spin). Sized by
 *  ``font-size`` (1em) and coloured by ``color``, like an antd icon. */
const LoadingCircle = ({ className }: { className?: string }) => (
  <svg
    className={classNames(styles.loadingCircle, className)}
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    aria-hidden
    focusable="false"
  >
    {Array.from({ length: TICKS }, (_, index) => (
      <line
        key={index}
        x1="12"
        y1="1.8"
        x2="12"
        y2="5"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        // Leading tick at 12 o'clock; the tail fades counter-clockwise.
        opacity={Math.max(0.08, 1 - index * 0.11)}
        transform={`rotate(${-index * (360 / TICKS)} 12 12)`}
      />
    ))}
  </svg>
);

export default LoadingCircle;
